module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sideways-page-one"
  }, [_c('div', {
    staticClass: "page-bar"
  }, [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.breadcrumbArray
    }
  })], 1), _vm._v(" "), (_vm.step === 0) ? _c('div', {
    staticClass: "flex-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('el-button', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.setStep(1)
      }
    }
  }, [_vm._v(" Create a new Layout")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.setStep(2), _vm.getLayouts()
      }
    }
  }, [_vm._v(" Open existing layout")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.step === 1) ? _c('div', {
    staticClass: "flex-center"
  }, [_c('div', [(_vm.type === 0) ? _c('h1', [_vm._v(" Create new layout ")]) : _vm._e(), _vm._v(" "), (_vm.type === 1) ? _c('h1', [_vm._v(" Edit layout Region: " + _vm._s(_vm.name) + " (" + _vm._s(this.displayCount) + " screens)")]) : _vm._e()]), _vm._v(" "), (_vm.type === 1) ? _c('div', [_c('h2', [_vm._v(" Click on a screen below to edit its regions")])]) : _vm._e(), _vm._v(" "), (_vm.type === 0) ? _c('div', [_c('el-input', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "placeholder": "Layout name"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 0) ? _c('div', [_c('el-button', {
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.setLayoutSize(1920, 1080)
      }
    }
  }, [_vm._v(" Horizontal (1920 x 1080)")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.setLayoutSize(1080, 1920)
      }
    }
  }, [_vm._v(" Vertical (1080 x 1920)")])], 1) : _vm._e(), _vm._v(" "), (_vm.type === 0) ? _c('div', [_vm._v("\n\t\t\t\t Number of screens "), _c('el-input-number', {
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.displayCount),
      callback: function($$v) {
        _vm.displayCount = $$v
      },
      expression: "displayCount"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 0) ? _c('div', [_c('el-button', {
    staticStyle: {
      "width": "8%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.createLayout()
      }
    }
  }, [_vm._v(" Save ")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "8%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.setStep(0)
      }
    }
  }, [_vm._v(" Cancel ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.displayCount), function(n, i) {
    return (_vm.type === 1) ? _c('div', {
      staticClass: "hoverDisplay",
      staticStyle: {
        "position": "relative",
        "display": "flex",
        "width": "auto!important",
        "margin": "0"
      },
      on: {
        "click": function($event) {
          _vm.setStep(3, 0, i), _vm.displayNumber = i
        }
      }
    }, [_c('div', {
      staticStyle: {
        "outline": "1px solid black"
      },
      style: ({
        width: _vm.layoutWidth / 60 + 'vw',
        height: _vm.layoutHeight / 60 + 'vw'
      }),
      attrs: {
        "id": "text-area",
        "disabled": ""
      }
    }, _vm._l((_vm.regionList), function(zone) {
      return (zone.screen === i) ? _c('div', {
        staticStyle: {
          "position": "absolute"
        },
        style: ({
          top: zone.y / 60 + 'vw',
          left: zone.x / 60 + 'vw',
          width: zone.width / 60 + 'vw',
          height: zone.height / 60 + 'vw',
          backgroundColor: zone.background
        }),
        attrs: {
          "disabled": ""
        }
      }) : _vm._e()
    }))]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.displayCount), function(n, i) {
    return (_vm.type === 0) ? _c('div', {
      staticClass: "hoverDisplay",
      staticStyle: {
        "position": "relative",
        "display": "flex",
        "width": "auto!important",
        "margin": "0"
      }
    }, [_c('div', {
      staticStyle: {
        "outline": "1px solid black"
      },
      style: ({
        width: _vm.layoutWidth / 60 + 'vw',
        height: _vm.layoutHeight / 60 + 'vw'
      }),
      attrs: {
        "id": "text-area",
        "disabled": ""
      }
    }, _vm._l((_vm.regionList), function(zone) {
      return (zone.screen === i) ? _c('div', {
        staticStyle: {
          "position": "absolute"
        },
        style: ({
          top: zone.y / 60 + 'vw',
          left: zone.x / 60 + 'vw',
          width: zone.width / 60 + 'vw',
          height: zone.height / 60 + 'vw',
          backgroundColor: zone.background
        }),
        attrs: {
          "disabled": ""
        }
      }) : _vm._e()
    }))]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('div', {
    staticClass: "flex-center"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_vm._l((_vm.layoutList), function(layout, index) {
    return [_c('el-button', {
      staticStyle: {
        "width": "25%"
      },
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.setStep(1, 1), _vm.setActiveLayout(index)
        }
      }
    }, [_vm._v(" " + _vm._s(layout.name) + " w: " + _vm._s(layout.width) + " h: " + _vm._s(layout.height) + " ")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          _vm.deleteLayout(layout.layout_id, index)
        }
      }
    }, [_vm._v(" Delete ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('div', {
    staticClass: "flex-center"
  }, [_c('div', [_c('div', [_c('h1', [_vm._v(" " + _vm._s(_vm.name) + " (Display " + _vm._s(_vm.displayNumber + 1) + "/" + _vm._s(_vm.displayCount) + ")")])]), _vm._v(" "), _c('button', {
    staticClass: "button btn",
    attrs: {
      "disabled": !_vm.displayNumber > 0
    },
    on: {
      "click": function($event) {
        _vm.prevDisplay()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left fa-2x"
  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tPrevious Display\n\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "button btn",
    on: {
      "click": function($event) {
        _vm.toggle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt fa-2x"
  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tFullscreen\n\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "button btn",
    attrs: {
      "disabled": !(this.displayNumber < this.displayCount - 1)
    },
    on: {
      "click": function($event) {
        _vm.nextDisplay()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right fa-2x"
  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tNext Display\n\t\t\t\t")])]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('span', {
    staticClass: "demonstration"
  }, [_vm._v("Zoom: ")]), _vm._v(" "), _c('el-slider', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "step": 0.1,
      "show-input": "",
      "min": 0.1,
      "max": 1
    },
    on: {
      "change": _vm.updatePadding
    },
    model: {
      value: (_vm.scale),
      callback: function($$v) {
        _vm.scale = $$v
      },
      expression: "scale"
    }
  })], 1)]), _vm._v(" "), _c('span', {
    staticClass: "demonstration"
  }, [_vm._v("Grid Size:  ")]), _vm._v(" "), _c('el-slider', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "step": 5,
      "show-input": "",
      "min": 5,
      "max": 20,
      "show-stops": ""
    },
    model: {
      value: (_vm.grid),
      callback: function($$v) {
        _vm.grid = $$v
      },
      expression: "grid"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "2px"
    }
  }, [_c('button', {
    staticClass: "button btn",
    on: {
      "click": function($event) {
        _vm.updateZones()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save fa-2x "
  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t  Save\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "button btn",
    on: {
      "click": function($event) {
        _vm.setStep(1, 1), _vm.getZones()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-th fa-2x"
  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t  MultiView\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "flex-wrap": "wrap"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('button', {
    staticClass: "button btn primary",
    on: {
      "click": function($event) {
        _vm.addNewRegion()
      }
    }
  }, [_vm._v(" Add region ")]), _vm._v(" "), _c('button', {
    staticClass: "button btn primary",
    on: {
      "click": function($event) {
        _vm.deleteRegion()
      }
    }
  }, [_vm._v(" Delete region ")])]), _vm._v(" "), _c('draggable', {
    on: {
      "end": _vm.onEnd
    }
  }, _vm._l((_vm.regionList), function(region, i) {
    return (region.background !== 'transparent' && region.screen === _vm.displayNumber) ? _c('div', {
      class: {
        'selectedBlock': i === _vm.selectedRegion
      },
      staticStyle: {
        "display": "inline-block:float:left",
        "color": "white",
        "padding": "5px"
      },
      style: ({
        'background-color': region.background
      }),
      attrs: {
        "id": 'minimap-' + i
      },
      on: {
        "click": function($event) {
          _vm.selectRegion(i)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(region.name) + " \n\t\t\t\t\t\t\t" + _vm._s(region.width) + "x" + _vm._s(region.height) + "\n")]) : _vm._e()
  }))], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "auto!important",
      "padding": "5px"
    },
    style: ({
      'margin-bottom': _vm.padding + 'px'
    })
  }, [_c('fs', {
    ref: "fs",
    attrs: {
      "fullscreen": _vm.fullscreen
    },
    on: {
      "update:fullscreen": function($event) {
        _vm.fullscreen = $event
      }
    }
  }, [_c('div', {
    staticClass: "layout-editor",
    staticStyle: {
      "background-image": "linear-gradient(to right, lightgrey 1px, transparent 1px), linear-gradient(to bottom, lightgrey 1px, transparent 1px)",
      "position": "relative",
      "transform-origin": "top",
      "outline": "5px solid black"
    },
    style: ({
      width: _vm.layoutWidth + 'px',
      height: _vm.layoutHeight + 'px',
      transform: 'scale(' + _vm.scale + ',' + _vm.scale + ')',
      'background-size': _vm.grid + 'px ' + _vm.grid + 'px'
    })
  }, [_vm._l((_vm.regionList), function(region, i) {
    return (region.background !== 'transparent' && region.screen === _vm.displayNumber) ? [_c('vue-draggable-resizable', {
      staticClass: "region",
      style: ({
        'background-color': region.background
      }),
      attrs: {
        "grid": [_vm.grid, _vm.grid],
        "id": ("region-" + i),
        "index": i,
        "x": region.x,
        "y": region.y,
        "w": region.width,
        "h": region.height,
        "z": region.z,
        "parent": true
      },
      on: {
        "activated": function($event) {
          _vm.selectRegion(i)
        },
        "dragging": _vm.onDrag,
        "resizing": _vm.onResize
      }
    }, [_c('span', {
      staticStyle: {
        "background-color": "rgba(0,0,0,0.5)",
        "color": "white",
        "border-radius": "4px",
        "padding": "2px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\ttop:" + _vm._s(region.y) + " left:" + _vm._s(region.x) + " "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(region.width) + "w " + _vm._s(region.height) + "h "), _c('br')])])] : _vm._e()
  })], 2)])], 1)], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(" Layouts ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(" Select a layout ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('h1', [_vm._v(" Toolbox ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('h1', [_vm._v(" Layers ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cacf7e50!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/Signage/Layout.vue
// module id = 458
// module chunks = 1